module.exports = __webpack_public_path__ + "static/img/game3.fdf87b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game3.jpg
// module id = cO+A
// module chunks = 1